import { render, staticRenderFns } from "./ModalProdutoNome.vue?vue&type=template&id=79663409&scoped=true&"
import script from "./ModalProdutoNome.vue?vue&type=script&lang=js&"
export * from "./ModalProdutoNome.vue?vue&type=script&lang=js&"
import style0 from "./ModalProdutoNome.vue?vue&type=style&index=0&id=79663409&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79663409",
  null
  
)

export default component.exports